import React from 'react';

import { Layout } from '@builty/components/Layout';

import './Dashboard.scss';


const TABLEAU_URL = (
  'https://public.tableau.com/views/CACoverage/coverage?:embed=y&:showVizHome=no&:host_url=https%3A%2F%2Fpublic.tableau.com%2F&' +
  ':embed_code_version=3&:tabs=no&:toolbar=yes&:animate_transition=yes&:display_static_image=no&:display_spinner=no&' +
  ':display_overlay=yes&:display_count=yes&:language=en-US&publish=yes&:loadOrderID=0'
);


export const Dashboard = () => {
  return (
    <Layout.Content>
      <iframe
        src={TABLEAU_URL}
        title="Tableau"
        className='c-dashboard__tableau'
        allowFullScreen
      ></iframe>
    </Layout.Content>
  );
}
